import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Select from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import searchFilterTerms from "@tKgpco/Handlers/Terms/SearchFilterTerms";
import setTermSearchFilter from "@tKgpco/Handlers/Terms/SetTermSearchFilter";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import { QuoteTermsFormValues } from "@tKgpco/Store/Data/Terms/TermsState";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    searchFilterTerms,
    setTermSearchFilter,
};

const mapStateToProps = (state: CustomApplicationState) => ({
    selectFilter: state.KGPState.customTerms.selectFilter,
    selectFilterText: state.KGPState.customTerms.selectFilterText,
});

interface CustomWidgetStyles {
    wrapper?: InjectableCss;
    searchBox?: TextFieldPresentationProps;
}

const styles: CustomWidgetStyles = {
    wrapper: {
        css: css`
            display: flex;
        `,
    },
    searchBox: {
        cssOverrides: {
            formField: css`
            > div {
                margin-top: 5px !important;
            }
            input {
                padding: 0 33px 0 10px !important;
            }
            `,
        }
    }
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const TermSearch: React.FC<Props> = ({
    id,
    searchFilterTerms,
    setTermSearchFilter,
    selectFilter,
    selectFilterText,
}) => {
    const doSearch = () => {
        if(selectFilterText === "") {
            searchFilterTerms({ queryParams: { page: 1 } });
        } else if (selectFilter && selectFilterText) {
            searchFilterTerms({ queryParams: { page: 1, [selectFilter as keyof QuoteTermsFormValues]: selectFilterText } });
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.keyCode !== 13) {
            return false;
        }
        doSearch();
    };

    useEffect(() => {
        return () => {
            setTermSearchFilter({ key: "selectFilter", value: "" })
            setTermSearchFilter({ key: "selectFilterText", value: "" })
        }
    },[]);

    useEffect(() => {
        doSearch();
    },[selectFilter, selectFilterText]);

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper
                css={css`
                    max-width: 250px;
                `}
            >
                <Select
                    value={selectFilter}
                    onChange={e => setTermSearchFilter({ key: "selectFilter", value: e.target.value })}
                >
                    <option disabled value="">
                        {translate("Select Column")}
                    </option>
                    <option value="TermsCode">{translate("Code")}</option>
                    <option value="Vendor">{translate("Vendor Item Id")}</option>
                    <option value="Type">{translate("Type")}</option>
                    <option value="Estimate">{translate("Estimate")}</option>
                    <option value="Description">{translate("Description")}</option>
                    <option value="source">{translate("Source")}</option>
                    <option value="Default">{translate("Default")}</option>
                </Select>
            </StyledWrapper>
            <TextField
                onChange={e => setTermSearchFilter({ key: "selectFilterText", value: e.target.value })}
                value={selectFilterText}
                placeholder={translate("Search")}
                iconClickableProps={{ onClick: doSearch }}
                iconProps={{ src: "Search", size: 16 }}
                onKeyDown={handleKeyDown}
                {...styles.searchBox}
            />
        </StyledWrapper>
    );
};

const termSearch: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(TermSearch),
    definition: {
        group: "Basic",
    },
};

export default termSearch;
